"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/tooltip/style/index.js
// module id = 367
// module chunks = 1